import { Flex, useColorModeValue } from "@chakra-ui/react";
import React, { Children, cloneElement, useEffect, useState } from "react";
import useSmallScreen from "../../components/useSmallScreen";

function BottomNavigationForMobile({ active, children }) {
  const [smallScreen] = useSmallScreen();
  const [clickState, setClickState] = useState(active);
  const containerColor = useColorModeValue("#fff", "#081b2e");

  const left = Children.toArray(children)[0];
  const right = Children.toArray(children)[1];

  const mobileStyle = {
    maxH: "80vh",
    overflowY: "scroll",
  };
  const largeStyle = {
    direction: ["column", "row"],
    alignItems: "flex-start",
    bg: containerColor,
    p: "10px",
    borderRadius: "15px",
    w: "100%",
  };
  useEffect(() => {
    setClickState(active);
  }, [active]);
  return (
    <>
      <Flex {...(smallScreen ? mobileStyle : {})}>
        {!smallScreen ? (
          <Flex {...largeStyle}>
            {cloneElement(left)}

            {cloneElement(right)}
          </Flex>
        ) : clickState === false ? (
          cloneElement(left)
        ) : clickState === true ? (
          cloneElement(right)
        ) : (
          cloneElement(left)
        )}
      </Flex>
    </>
  );
}

export default BottomNavigationForMobile;
